<template>
  <div>
   <el-dialog
      title="从调查员库选择"
      class="theme-dialog add-investigator-dialog dialog-center dialog-body-0"
      top="0"
      :visible.sync="visible"
      width="70%"
      :modal="false"
      :destroy-on-close="true"
      :before-close="handleClose"
    >
      <div class="table-body">
        <!-- <el-button @click="()=>(this.conditionVisible = true)" type="link">高级筛选</el-button> -->
        <DialogConditionBtn :filter.sync="filter" :btnText="'高级筛选'" :btnPlain="true" @save="onSaveFilter"></DialogConditionBtn>
        <!-- <el-table
          class="mt-4"
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="date"
            label="日期"
            width="180">
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            width="180">
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址">
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-4"
          style="text-align: right;"
          @size-change="emit('size-change', $event)"
          @current-change="emit('pagination-current-change', $event)"
          :current-page.sync="page.current"
          :page-sizes="page.pageSizes"
          :page-size.sync="page.size"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
          :pager-count="5"
        >
        </el-pagination> -->
        <DataTable
          ref="crud"
          class="avue1"
          :page="page"
          :showPage="true"
          :data="tableData"
          :columns="columns"
          :selection="true"
          @selection-change="selectionChange"
          :loading="loading"
          rowKey="id"
          :isShowCheckCount="true"
          @size-change="sizeChange"
          @pagination-current-change="currentChange"
          :height="'45vh'"
        >
          <template slot="empty">
            <div>调查员库中还未添加调查员</div>
          </template>
          <!-- 上传文件的展示 -->
          <template v-for="item in fillList" :slot="item" slot-scope="scope">
            <div :key="item">
              <div v-if="showImg(scope.row[item]) === '-'">-</div>
              <el-image v-else-if="showImg(scope.row[item])" style="width: 120px" :src="baseURL + scope.row[item]" :preview-src-list="bigImgUrl" @click="showBigImg(scope.row[item])" />
              <el-button v-else type="text" @click="openFill(scope.row[item])">{{decodeURIComponent(scope.row[item]) | fillName}}</el-button>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="btn-footer">
        <el-button @click="handleClose" style="width: 88px">取消</el-button>
        <el-button type="primary" @click="dialogConfirm" style="width: 88px">确认</el-button>
      </div>
    </el-dialog>
    <SearchCondition :visible="conditionVisible" />
  </div>
</template>
<script>
import SearchCondition from '@/components/base/SearchCondition.vue'
import DialogConditionBtn from '@/views/home/more-app/investigator-lib/DialogConditionBtn.vue'
import DataTable from '@/components/base/DataTable'
import { getTableHeader, getTable } from '@/api/more-app/investigator-base'
export default {
  name: 'AddInvestigator',
  components: { SearchCondition, DialogConditionBtn, DataTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  // 传递给BaseCondition组件的参数用来适配 高级筛选的请求参数
  provide(){  
    return {  
        params:{
          showStatFields: false,
          investigatorFilter:false
        } 
    }  
  },
  data() {
    return {
      baseURL: window.location.origin + '/fill/api/v1/download?fileName=',
      conditionVisible:false,
      filter: {
        conditionRule: 2,
        ruleGroups: [],
        rules: []
      },
      loading:false,
      page:{
        current:1,
        pageSizes:[10,20,30,40,50],
        size:10,
        total:100
      },
      columns:[],
      catchColumnsData:[],
      tableData: [],
      selectionList:[],
      fillList: [],
      imgType: ['.png', '.jpeg', '.jpg', '.bmp', '.gif'],
      bigImgUrl: [''],
    }
  },
  filters: {
    fillName(val) {
      return val.split('_')[1]
    }
  },
  created() {
    this.getColumns();
  },
  methods: {
    // 设置大图路径
    showBigImg(val) {
      this.bigImgUrl = [`${this.baseURL + val}`]
    },
    // 打开表格中的文件
    openFill(val) {
      window.open(this.baseURL + val)
    },
    // 表格中的图片是否展示
    showImg(val) {
      if(val === '--') return val
      return this.imgType.some(item => val.includes(item))
    },
    handleClose(){
      this.$emit('handleClose',false)
    },
    dialogConfirm(){
      this.$emit('handleClose',false,this.selectionList)
    },
    // 高级筛选
    onSaveFilter(event) {
      // this.getData()
     console.log('onSaveFilter',event )
     if(event){
      this.filter = event;
     }
     this.page.current = 1;
     this.page.size = 10;
     this.getTableList(event);
    },
    // 分页切换查询方法
    currentChange(val){
      console.log('currentChange-val',val)
      this.page.current = val;
      this.getTableList();
    },
    // 切换分页器
    sizeChange(val){
      console.log('sizeChange-val',val)
      this.page.size = val;
      this.getTableList();
    },
    // 勾选的数据
    selectionChange(list){
      this.selectionList = list;
    },
    // 获取动态列数据
    getColumns(){
      getTableHeader().then((res)=> {
        if(res.data.code === 0){
          this.catchColumnsData = res.data.data;
          const filterFieldsStr = [
            '明察暗访项目数',
            '上报案件数',
            '审核案件数',
            '审核案件通过率',
            '问卷调查项目数',
            '上报答卷数',
            '审核答卷数',
            '答卷审核通过率',
            '结算项目数',
            '结算金额',
            '黑名单',
            '分配任务',
            '回收数据',
            'id'
          ]
          const filterColumns = res.data.data.filter(it=> !filterFieldsStr.includes(it.name))
          this.columns = filterColumns.map((it,i)=> (
            { ...it,
              fixed: i <= 1 ? 'left' : false,
              label:it.name,
              value:it.id,
              width: 150,
              tooltip: it.questionType !== 18
            }))
            this.fillList = filterColumns.map(item => {
              if(item.questionType === 18) return item.id
            })
            this.fillList = this.fillList.filter(item => {return item})
        }
      }).then(()=> {
        this.getTableList();
      })
    },
    // 获取表格数据
    getTableList (filter = this.filter){
      getTable(filter, {
        current:this.page.current,
        size:this.page.size
      }).then(res=> {
        if(res.data.code === 0){
          this.page.total = res.data.data.total;
          const list = [];
          const dataList = res.data.data.records;
          dataList.forEach(item=> {
            const obj = {};
            for(let key in item){
                this.catchColumnsData.forEach((it,idx)=> {
                obj[it.id] = item[idx] || '-'
              })
            }
            list.push(obj)
          })
          this.tableData = list;
        }
      })
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
.add-investigator-dialog{
  .el-dialog__body{
    height: 564px;
    .table-body{
      height: calc(100% - 64px);
      padding:16px;
      box-sizing: border-box;
    }
    .btn-footer{
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      padding: 16px;
      text-align: right;
      box-sizing: border-box;
    }
  }
}
</style>
